import React          from 'react';
import sizes          from 'utils/sizes';
import closedBox      from 'images/closedBox.png';
import { makeStyles } from "makeStyles";
//import { objType }    from 'types';


const useStyles = makeStyles()(
    (theme) => ({
    root: {
        width:              '100%',
        height:             '100%',
        backgroundPosition: 'center',
        backgroundSize:     'contain',
        backgroundRepeat:   'no-repeat',
        display:            'flex',
        alignItems:         'center',
        flexFlow:           'column',
        touchAction:        'manipulation',
    }
  })
);

type TensProps = {
    value:       number;
    wideScreen:  boolean;
    position:    string;
}

const Tens: React.FC<TensProps> = ({ 
  value,
  wideScreen,
  position,
}) => {

  const { classes } = useStyles();

  
  const [boxHeight, boxGap, rootStyle] = React.useMemo(() => {
    const { 
      bigBoxWidth, 
      bigBoxHeight, 
      bigBoxGap,
      smallBoxGap,
      smallBoxHeight 
    } = sizes;

    const width          = wideScreen ? bigBoxWidth : '19vw';
    const height         = wideScreen ? bigBoxHeight : smallBoxHeight;
    const gap            = wideScreen ? bigBoxGap : smallBoxGap;

    const style = {
      backgroundImage: `url(${ closedBox })`,
      width:           width,
      minWidth:        width,
      height:          height,
      minHeight:       height,
    }

    return [
      height,
      gap,
      style,
     ]
  },[/* value,  */wideScreen])

  return (
    <div style = {{ transform: `translate(0%, -${ (( boxGap * value)) / 2 }px)`, height: (boxHeight + (boxGap * (value) - 1)) }} >
          {
            new Array(value).fill(0).map((val, ind) => {

              const translate = -(boxHeight * ind) + (boxGap * ind);

              return(
                <div 
                   key       = { `innerTens${ ind }` }
                   className = { classes.root }
                   style     = {{
                     ...rootStyle,
                     transform: `translate(${ ind * 3 }px, ${ translate }px)`
                   }}
                />
              )
            })
          }
    </div>    
  );
}



export default Tens;








